import http from './api'

const route = '/recibos/'

export default {

    listarRecibos: (empresaId, produtorId, dataInicio) => {
        return http.post(route + 'listar_recibos', {
            produtor_id: produtorId,
            empresa_id: empresaId,
            datainicio: dataInicio,
        })
    },
    listarLaticinios: (chaveativacao) => (
        http.post(route + 'listar_empresas', { chaveativacao: chaveativacao })
    ),
    listarItensRecibo: (idRecibo) => {
        return http.post(route + 'listar_itens_recibo', {
            recibo_id: idRecibo,
        })
    },
}
